import React from "react";
import moment from "moment";
import { useHistory } from "react-router-dom";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import CardContent from "@mui/material/CardContent";
import Avatar from "@mui/material/Avatar";
import Typography from "@mui/material/Typography";
import Chip from "@mui/material/Chip";
import Box from "@mui/material/Box";
import CardActionArea from "@mui/material/CardActionArea";

//import BookmarkBorderIcon from "@mui/icons-material/BookmarkBorder";
//import AssignmentOutlinedIcon from "@mui/icons-material/AssignmentOutlined";
import PeopleAltOutlinedIcon from "@mui/icons-material/PeopleAltOutlined"; // shared
//import StarBorderIcon from "@mui/icons-material/StarBorder";
//import TimerOutlinedIcon from "@mui/icons-material/TimerOutlined";
//import PersonOutlineIcon from "@mui/icons-material/PersonOutline"; // owner

import { getColor } from "../tools";
import { useSetSearchParam } from "../useSearchParams";
import { getInteractionByType } from "../User/Create/interactions";

export default function SearchResult({
  item,
  tags,
  selectedItem,
  isEditable,
}) {
  const history = useHistory();
  const search = useSetSearchParam("i", item.id);
  const interaction = getInteractionByType(item.interactionType);
  const preventDefault = (event) => event.preventDefault();

  const handleClick = (event) => {
    preventDefault(event);
    history.push({
      search,
      state: {
        from: "library",
        item,
      },
    });
  };
  return (
    <Card
      variant="outlined"
      sx={{ boxShadow: selectedItem === item.id ? 4 : 0 }}
    >
      <CardActionArea onClick={handleClick}>
        <CardHeader
          avatar={
            <Avatar
              aria-label="recipe"
              variant="rounded"
              sx={{ backgroundColor: getColor(item.name) }}
            >
              {<interaction.icon />}
            </Avatar>
          }
          title={
            <Typography
              variant="h6"
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
              }}
            >
              {item.name}
              {isEditable && item.public !== 0 ? (
                <PeopleAltOutlinedIcon sx={{ color: "text.secondary" }} />
              ) : null}
            </Typography>
          }
          subheader={
            <Typography variant="body2" color="textSecondary">
              {/* <PersonOutlineIcon fontSize="small" /> */}
              From: {item.firstName} {item.lastName} @{item.code} &#8226;{" "}
              {item?.lastChanged
                ? moment(item.lastChanged).format("D MMM YYYY")
                : ""}
            </Typography>
          }
        />
        <CardContent sx={{ paddingTop: 0 }}>
          <Typography variant="body2" color="textSecondary" component="p">
            {item.description}
          </Typography>
          <Box flexGrow={1}>
            {tags.map((tag) => (
              <Chip
                key={tag.id}
                size="small"
                label={tag.tag}
                sx={{ marginTop: 1, marginRight: 1 }}
              />
            ))}
          </Box>
        </CardContent>
      </CardActionArea>
      {/* <CardActions disableSpacing sx={{paddingLeft:2, paddingRight:2}}>
       <Box marginRight={2} >
          <Typography variant="subtitle2" color="textSecondary">
            <TimerOutlinedIcon style={{ verticalAlign: "middle" }} />{" "}
            {item.duration}
          </Typography>
        </Box> */}

      {/* <Box marginRight={2} >
          <Typography variant="subtitle2" color="textSecondary">
            <PeopleAltOutlinedIcon
              fontSize="small"
              style={{ verticalAlign: "middle" }}
            />{" "}
            {item.used}
          </Typography>
        </Box>

        <Box>
          <Typography variant="subtitle2" color="textSecondary">
            <StarBorderIcon
              fontSize="small"
              style={{ verticalAlign: "middle" }}
            />{" "}
            {item.stars}
          </Typography>
        </Box> 
      </CardActions>*/}
    </Card>
  );
}
